export default "__VITE_ASSET__LNwvP2Nd__"